import Icon from '../generic/Icon';
import * as style from './Expandable.module.css';

export interface Props {
    expanded: boolean;
}

//TODO: the expand button should probably use chevron down and it should rotate based on aria-expanded

export default function ExpandButton({ expanded }: Props) {
    return (
        <div className={style.expandButton}>
            <Icon className={expanded ? 'icon-decrease' : 'icon-increase'} />
        </div>
    );
}
